// Core
import { useEffect } from 'react'
import { isRouteErrorResponse, Navigate, useRouteError } from 'react-router-dom'

// App
import { Button } from '@src/components/ui/button'
import Err500Image from '@src/assets/images/error/err500.png'

// Internal
import './RouterErrorBoundary.css'

// Chunk load errors (stale hashed assets after deploy / flaky network)
const CHUNK_ERROR_PATTERN =
  /dynamically imported module|ChunkLoadError|Importing a module script failed|Loading chunk \d+ failed/i
const RELOAD_THROTTLE_KEY = 'chunk-error-reload'
const RELOAD_THROTTLE_MS = 30_000

// Component
const RouterErrorBoundary = () => {
  const error = useRouteError()
  const isRouteError = isRouteErrorResponse(error)
  const isChunkError = error instanceof Error && CHUNK_ERROR_PATTERN.test(error.message)

  // Log real error so it can be diagnosed from DevTools console
  useEffect(() => {
    console.error('[RouterErrorBoundary]', error)
  }, [error])

  // Auto reload once (throttled) — fresh index.html resolves new chunk names
  useEffect(() => {
    if (!isChunkError) return
    const lastReload = Number(sessionStorage.getItem(RELOAD_THROTTLE_KEY) ?? 0)
    if (Date.now() - lastReload < RELOAD_THROTTLE_MS) return
    sessionStorage.setItem(RELOAD_THROTTLE_KEY, String(Date.now()))
    window.location.reload()
  }, [isChunkError])

  // Methods
  // Handle click
  const handleClick = () => {
    window.location.href = '/user'
  }

  // Template
  if (isRouteError && error.status === 404) {
    return <Navigate to='/authentication/sign-in' replace />
  }

  return (
    <div className='w-screen h-screen flex justify-center items-center py-10'>
      <div className='app-container'>
        <div className='flex flex-col lg:flex-row justify-center items-center gap-10 lg:gap-20'>
          <img src={Err500Image} className='w-1/2 lg:w-1/3' />
          <div className='flex flex-col items-center gap-4'>
            <h2 className='text-app-blue font-bold text-2xl'>Oops! Có lỗi xảy ra</h2>
            <Button onClick={handleClick}>Trở về trang chủ</Button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default RouterErrorBoundary
